import React from 'react';
import ManateeDropdown from '../ManateeDropdown';
import './style.css';

const styles = {
    button: {
        backgroundColor: '#C8CDD4',
        padding: 5
    },
    list: {
        padding: 5,
        cursor: 'pointer',
    }
};

const ContextMenu = ({ contextMenuOptions }) => {
    try {
        
        const Dropdown_trigger = ({ toggle_dropdown }) => (
            <div className="btn context-menu-trigger" style={styles.button}  onClick={(e) => {e.stopPropagation();toggle_dropdown();}} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <span className="fas fa-lg fa-ellipsis-h"/>
            </div>
        );

        const Dropdown_dropper = () => (
            <ul style={{ marginTop: '-12px', left: 16 }} className="dropdown-menu" aria-labelledby="dropdownMenu1">
                {contextMenuOptions.map((option, id) => (
                    <li className="context-menu-items" style={styles.list} key={'contextMenuItem' + id} onClick={(e) => {e.stopPropagation();option.action(e)}}>
                        {option.name}
                    </li>
                ))}
            </ul>
        );

        return (
            <div className="dropdown folder-options-dropdown">
                <ManateeDropdown 
                    Trigger={Dropdown_trigger}
                    Dropper={Dropdown_dropper}
                />
            </div>
        );
    } catch(err) {
        console.log('error in ContextMenu --< >>>>>', err)
        return '';
    }
}

export default ContextMenu;